import React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import upvotefollowListClasses from "@styles/profile/upvoteFollowList.module.css";
import { Typography } from "@mui/material";
const ListModal = (props) => {
  function closeModal() {
    if (props.setShowList) props.setShowList(false);
  }

  return (
    <Modal open={props.show}>
      <div className={upvotefollowListClasses.root}>
        <div className={upvotefollowListClasses.main}>
          <div className={upvotefollowListClasses.heading}>
            <Typography>{props.heading}</Typography>
            <CloseIcon
              className={upvotefollowListClasses.closeBtn}
              onClick={closeModal}
            />
          </div>

          <div className={upvotefollowListClasses.list_container}>
            {props.children}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ListModal;
